import { stringify } from 'yaml';

import { CodeCard, CodeData } from '@/components/Code/Code';
import { cn } from '@/utils/tailwind';

import { ManifestEditorProps, ManifestPreviewProps } from '../Manifest.utils';
import { ManifestNavigation } from '../ManifestNavigation';

export function ManifestGeneric<T>(props: ManifestEditorProps<T>) {
  return (
    <CodeCard>
      <div className="border-b border-slate-300 p-4 dark:border-[rgb(62,62,72)]">
        <ManifestNavigation navigation={props.navigation} />
      </div>
      <CodeData value={props.value} onChange={props.onChange} />
    </CodeCard>
  );
}

export function ManifestGenericPreview<T>(props: ManifestPreviewProps<T>) {
  if (props.variant === 'line') {
    return <>{stringify(props.value).split('\n').at(0)}</>;
  }

  return (
    <button
      type="button"
      onClick={props.onClick}
      className={cn(
        'flex w-auto flex-col rounded-md border bg-slate-50 p-3 shadow-sm dark:border-[rgb(24,24,24)] dark:bg-[rgb(9,9,13)]',
        props.onClick ? 'cursor-pointer' : 'cursor-default'
      )}
    >
      <pre className="max-w-full overflow-hidden text-ellipsis whitespace-pre-wrap">
        {stringify(props.value).split('\n').slice(0, 3).join('\n')}
      </pre>
    </button>
  );
}
